import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { onError } from 'apollo-link-error';
import stateLink from './stateLink';
import { AUTH_TOKEN, GUEST_TOKEN, LOCALE } from 'config/constants';
import { toast } from 'react-toastify';

let httpLink;

// httpLink = new HttpLink({ uri: `https://staging.lynks.com/graphql` });
httpLink = new HttpLink({ uri: 'http://localhost:3030/graphql' });
// httpLink = new HttpLink({ uri: `http://192.168.0.10:3030/graphql` });
// httpLink = new HttpLink({ uri: 'https://api.lynks.com/graphql' });

if (process.env.NODE_ENV === 'production') {
  httpLink = new HttpLink({ uri: 'https://api.lynks.com/graphql' });
}

if (process.env.IS_SANDBOX === 'true') {
  httpLink = new HttpLink({ uri: 'https://sandbox-api.lynks.com/graphql' });
}

if (process.env.IS_STAGING === 'true') {
  httpLink = new HttpLink({ uri: 'https://staging-api.lynks.com/graphql' });
}

// auth link
const middlewareAuthLink = new ApolloLink((operation, forward) => {
  const token =
    localStorage.getItem(AUTH_TOKEN) || localStorage.getItem(GUEST_TOKEN);
  const authorizationHeader = token ? `Bearer ${token}` : null;

  operation.setContext({
    headers: {
      authorization: authorizationHeader,
      'App-Locale': localStorage.getItem(LOCALE) || 'ar',
      'App-Session': JSON.stringify(sessionStorage),
    },
  });
  return forward(operation);
});

const httpLinkWithAuthToken = middlewareAuthLink.concat(httpLink);

// retry link
let retryToast;
let delay = 5000;
const retry = new RetryLink({
  // eslint-disable-next-line no-unused-vars
  delay: (count, operation, error) => {
    if (count > 1 && !(count % 5) && navigator.onLine) {
      delay += 5000;
      if (!toast.isActive(retryToast)) {
        retryToast = toast.warn(
          `Operation failed, will retry in ${delay / 1000} seconds.`,
          {
            autoClose: delay,
            onClose: () => {
              retryToast = null;
            },
          }
        );
      }
      return delay;
    }
    return 1000;
  },
  // eslint-disable-next-line no-unused-vars
  attempts: (count, operation, error) => {
    if (!error) {
      retryToast = null;
      return false;
    }
    if (error.statusCode === 401) {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(GUEST_TOKEN);
      window.location.reload();
      return false;
    }
    if (error.statusCode === 500 && process.env.NODE_ENV !== 'production') {
      return false;
    }
    return true;
  },
});
const httpLinkWithAuthTokenAndRetry = retry.concat(httpLinkWithAuthToken);

// onError link
// eslint-disable-next-line no-unused-vars
let networkErrorToast;
const errorAfterware = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log('graphQLErrors', graphQLErrors);
    // graphQLErrors.map(({ message, locations, path }) => {
    //   const msg = `[GraphQL error]: Message: ${message}, Location: {line: ${
    //     locations[0].line
    //   }, column:${locations[0].column}}, Path: ${path}`;
    //   // eslint-disable-next-line no-console
    //   console.log(msg);
    //   // Should be handled case by case
    //   // if (!toast.isActive(graphQLErrorToast)) {
    //   //   graphQLErrorToast = toast.error("Something went wrong, our team got notified about this issue, we're working hard to get our beta version stable as soon as possible.", {
    //   //     onClose: () => {graphQLErrorToast = null}
    //   //   })
    //   // }
    // });
  }

  if (networkError) {
    console.log('networkError', networkError);
    // const msg = `[Network error]: ${networkError}`;
    // logger.error(msg);
    // if (!toast.isActive(networkErrorToast)) {
    //   networkErrorToast = toast.warn(
    //     'We are having issues to connect with our servers, please try again later.',
    //     {
    //       autoClose: false,
    //       onClose: () => {
    //         networkErrorToast = null;
    //       },
    //     }
    //   );
    // }
    // // console.log(msg)
  }
});

const httpLinkWithAuthTokenAndRetryAndErrorHandling = errorAfterware.concat(
  httpLinkWithAuthTokenAndRetry
);

// const wsLink = new WebSocketLink({
//   uri: `ws://localhost:3030/graphql`,
//   options: {
//     reconnect: true,
//     connectionParams: {
//       authToken: token,
//     },
//   }
// })

// const link = split(
//   ({ query }) => {
//     const { kind, operation } = getMainDefinition(query)
//     return kind === 'OperationDefinition' && operation === 'subscription'
//   },
//   wsLink,
//   httpLinkWithAuthToken,
// )

const apolloLink = ApolloLink.from([stateLink, httpLinkWithAuthTokenAndRetry]);

export default apolloLink;



// WEBPACK FOOTER //
// ./app/apolloLink.js